import { RouteRecordRaw } from 'vue-router'

const shujumingxi: Array<RouteRecordRaw> = [{
    path: '/shujumingxi',
    meta: {
        title: "战队用户数据明细"
    },
    component: () => import("@/views/shujumingxi/list.vue")
}];
export default shujumingxi;